import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PendingComponent } from './pending/pending.component';
import { DetailLegacyComponent } from './detail-legacy/detail-legacy.component';
import { TerverifikasiComponent } from './terverifikasi/terverifikasi.component';
import { RejectComponent } from './reject/reject.component';
import { MacRegistrationComponent } from './mac-registration/mac-registration.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'terverifikasi/list/active',
    pathMatch: 'full',
  },
  {
    path: 'pending/:tab',
    component: PendingComponent,
  },
  {
    path: 'terverifikasi/:tab',
    component: TerverifikasiComponent,
  },
  {
    path: 'reject',
    component: RejectComponent,
  },
  {
    path: 'detail/:tab/:status/:id',
    component: DetailLegacyComponent,
  },
  {
    path: 'detail/:status/:tab/:view/:id',
    component: DetailLegacyComponent,
  },
  {
    path: 'registrasi-mac',
    component: MacRegistrationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RetailerRoutingModule {}
